<template>
    <div>
        <div class="inner-wrapper">
            <section role="main" class="content-body">
                <div class="grid grid-logo">
                    <div class="row space-bot">
                        <!--Logo-->
                        <div class="" style="text-align:center;">
                            <a href="/">
                                <img v-if="rs_data.logo" :src="'/assets/img/logo/logo-rs/' + rs_data.logo" class="logo" alt="" style="width:140px;">
                            </a>
                        </div>
                        <!--Menu-->
                    </div>
                </div>
                <div class="undermenuarea" style="background-color:#007d7d;">
                    <div class="boxedshadow"></div>

                    <!-- SLIDER AREA
                    ================================================== -->
                    <div class="grid">
                        <div class="row">
                        <div class="c12" style="text-align:center;">
                            <div class="titlehead" style="text-align:center;">
                                <span style="font-size: 26px;font-weight: bold;">{{ rs_data.app_title }}</span>
                                <p style="font-size: 18px;margin-bottom: -26px;">{{ rs_data.app_desc }}</p>
                                <br><span style="font-size: 26px;font-weight: bold;">{{ rs_data.name }}</span>
                                <br><span style="font-size: 20px;font-weight: bold;">{{ rs_data.address + ' Telp. ' + rs_data.phone }}</span>
                            </div>

                            <router-link to="/" style="color:white;" class=""><i class="fa fa-home"></i>&nbsp; Halaman Utama</router-link>
                        </div>
                        <!-- <div class="c4">
                            <h1 class="titlehead rightareaheader"><i class="icon-map-marker"></i> Call Us Now 1-318-107-432</h1>
                        </div> -->
                        </div>
                    </div>
                </div>

                <div v-if="user" class="undersliderblack" style="height:87px;">
                    <div class="grid">
                        <div class="row space-bot">
                        <div class="c12">
                            <nav id="topNav">
                            <ul id="responsivemenu">
                                <li class=""><router-link to="/" style="color:white"><i class="fa fa-home"></i> Home</router-link></li>
                                <li class=""><router-link to="/portal" style="color:white"><i class="fa fa-cog"></i> Portal</router-link></li>
                                <li class=""><router-link to="#" style="color:white" @click.native="doLogout"><i class="fa fa-sign-out"></i> Logout</router-link></li>
                            </ul>
                            </nav>
                        </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div>
            <section role="main">
                <b-container fluid="md">
                    <router-view></router-view>
                </b-container>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: null,
            access_token: null,
            rs_data: {
                id: 0,
                name: '',
                logo: '',
                address: '',
                phone: '',
                app_title: '',
                app_desc: '',
                metode_antrean: '',
            }
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getRsData()
        },
        getRsData() {
            this.$isLoading(true)
            let uri = '/api/get_rs_data?id=1'

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    let rs_data = response.data.rs_data
                    if (rs_data) {
                        this.rs_data = {
                            id: rs_data.id,
                            name: rs_data.rs_name,
                            logo: rs_data.rs_logo,
                            address: rs_data.rs_address,
                            phone: rs_data.rs_phone,
                            app_title: rs_data.app_title,
                            app_desc: rs_data.app_desc,
                            metode_antrean: rs_data.metode_antrean,
                        }
                    }
                }

                this.$isLoading(false)
            })
        },
        doLogout() {
            localStorage.setItem('user', '')
            localStorage.setItem('access_token', '')

            location.href = '/'
        }
    }
}
</script>
